import React, { ReactNode } from "react";
import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { InfoIcon } from "@chakra-ui/icons";

interface InfoPanelProps {
  children: ReactNode;
}

export const InfoPanel = ({ children }: InfoPanelProps) => {
  return (
    <Box
      borderWidth="1px"
      borderColor="blue.200"
      bg="blue.50"
      borderRadius="md"
      p={4}
      boxShadow="sm"
    >
      <Flex align="flex-start">
        <Icon as={InfoIcon} color="blue.400" boxSize={5} mt={1} mr={3} />
        <Text fontSize="sm" color="gray.700">
          {children}
        </Text>
      </Flex>
    </Box>
  );
};
